<template>
  <div class="animated fadeIn">
    <!-- <b-card no-body >
      <b-card-body class="p-4"> -->
        <b-form validated novalidate @submit="changePassword">
          <b-col sm="12">
            <b-form-group label-for="new_password" label="New Password">
              <b-form-input
                id="new_password"
                type="text"
                v-model="$v.changepasswordForm.new_password.$model"
                :state="!$v.changepasswordForm.new_password.$invalid"
                required
                placeholder="New Password"
              ></b-form-input>
              <b-form-invalid-feedback
                >New Password harus di isi.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>

          <b-button v-if="!isDisable" type="submit" variant="success"
            >Change Password</b-button
          >
        
        </b-form>
      <!-- </b-card-body>
    </b-card> -->
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
export default {
  name: "employee-forgot-password",
  components: { loading, ModelSelect, MultiSelect, loading },
  data() {
    return {
      changepasswordForm: masterInterfaces.change_password,
    };
  },
  props: {
    isDisable: {
      type: Boolean,
      default: true,
    },
    nik: {
      type: String,
      default: '',
    },
    loadingParam: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    changepasswordForm: {
      new_password: { required },
    },
  },

  methods: {
    init: function () {
      this.resetForm();
    },

    back: function () {
      this.$router.go(-1);
    },

    resetForm: function () {
      for (var a in masterInterfaces.change_password) {
        masterInterfaces.change_password[a] = null;
      }
      this.accessForm = masterInterfaces.change_password;
    },

    back: function () {
      this.$router.go(-1);
    },
    changePassword: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Password ?")) {
        this.changepasswordForm.nik = this.nik;//localStorage.getItem("nik");
        this.axios
          .put("tools/change-password/edit/", this.changepasswordForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Password",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Password");
          })
          .finally(() => {
            this.resetForm();
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>
